import React from 'react';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/i18n-react';
import { IconButton } from '@fiverr-private/button';
import { ArrowRightIcon } from '@fiverr-private/icons';

import styles from './index.module.scss';

export const ContactOptionRow = ({ renderIcon, translationRoute, onClick = noop }) => {
    const Icon = renderIcon;

    return (
        <div className={styles.dropdownOption} onClick={onClick}>
            <div className={styles.iconTextSection}>
                <span className={styles.notShrinking}>
                    <IconButton size={'md'} shape={'circle'} disabled={true}>
                        <Icon size={16} />
                    </IconButton>
                </span>
                <I18n k={translationRoute} />
            </div>
            <span className={styles.notShrinking}>
                <ArrowRightIcon size={16} />
            </span>
        </div>
    );
};
